__turbopack_export_value__({
  "body-logo-18": "ControlledScoreSelect-module-scss-module__KAZM9W__body-logo-18",
  "body-text-12": "ControlledScoreSelect-module-scss-module__KAZM9W__body-text-12",
  "body-text-14": "ControlledScoreSelect-module-scss-module__KAZM9W__body-text-14",
  "body-text-16": "ControlledScoreSelect-module-scss-module__KAZM9W__body-text-16",
  "body-text-18": "ControlledScoreSelect-module-scss-module__KAZM9W__body-text-18",
  "body-text-20": "ControlledScoreSelect-module-scss-module__KAZM9W__body-text-20",
  "body-text-24": "ControlledScoreSelect-module-scss-module__KAZM9W__body-text-24",
  "body-text-24-2": "ControlledScoreSelect-module-scss-module__KAZM9W__body-text-24-2",
  "body-text-heading-2": "ControlledScoreSelect-module-scss-module__KAZM9W__body-text-heading-2",
  "body-text-heading-3": "ControlledScoreSelect-module-scss-module__KAZM9W__body-text-heading-3",
  "body-text-medium-14": "ControlledScoreSelect-module-scss-module__KAZM9W__body-text-medium-14",
  "body-text-medium-16": "ControlledScoreSelect-module-scss-module__KAZM9W__body-text-medium-16",
  "body-text-medium-18": "ControlledScoreSelect-module-scss-module__KAZM9W__body-text-medium-18",
  "body-text-medium2-18": "ControlledScoreSelect-module-scss-module__KAZM9W__body-text-medium2-18",
  "body-text2-14": "ControlledScoreSelect-module-scss-module__KAZM9W__body-text2-14",
  "body-text2-16": "ControlledScoreSelect-module-scss-module__KAZM9W__body-text2-16",
  "button-primary-text": "ControlledScoreSelect-module-scss-module__KAZM9W__button-primary-text",
  "button-text": "ControlledScoreSelect-module-scss-module__KAZM9W__button-text",
  "button2-text": "ControlledScoreSelect-module-scss-module__KAZM9W__button2-text",
  "card-shadow": "ControlledScoreSelect-module-scss-module__KAZM9W__card-shadow",
  "effect-menu": "ControlledScoreSelect-module-scss-module__KAZM9W__effect-menu",
  "errorHint": "ControlledScoreSelect-module-scss-module__KAZM9W__errorHint",
  "errorHint_visible": "ControlledScoreSelect-module-scss-module__KAZM9W__errorHint_visible",
  "header-1": "ControlledScoreSelect-module-scss-module__KAZM9W__header-1",
  "label": "ControlledScoreSelect-module-scss-module__KAZM9W__label",
  "main-container": "ControlledScoreSelect-module-scss-module__KAZM9W__main-container",
  "main-footer-container": "ControlledScoreSelect-module-scss-module__KAZM9W__main-footer-container",
  "main-header-container": "ControlledScoreSelect-module-scss-module__KAZM9W__main-header-container",
  "stars": "ControlledScoreSelect-module-scss-module__KAZM9W__stars",
  "stars__star": "ControlledScoreSelect-module-scss-module__KAZM9W__stars__star",
  "stars__star_active": "ControlledScoreSelect-module-scss-module__KAZM9W__stars__star_active",
  "txt-12-bold": "ControlledScoreSelect-module-scss-module__KAZM9W__txt-12-bold",
  "txt-14-bold": "ControlledScoreSelect-module-scss-module__KAZM9W__txt-14-bold",
  "txt-14-bold-caps": "ControlledScoreSelect-module-scss-module__KAZM9W__txt-14-bold-caps",
  "txt-14-med": "ControlledScoreSelect-module-scss-module__KAZM9W__txt-14-med",
  "txt-16-bold": "ControlledScoreSelect-module-scss-module__KAZM9W__txt-16-bold",
  "txt-16-med": "ControlledScoreSelect-module-scss-module__KAZM9W__txt-16-med",
  "txt-18-bold": "ControlledScoreSelect-module-scss-module__KAZM9W__txt-18-bold",
  "txt-18-medium": "ControlledScoreSelect-module-scss-module__KAZM9W__txt-18-medium",
  "txt-18-medium-24": "ControlledScoreSelect-module-scss-module__KAZM9W__txt-18-medium-24",
  "txt-24-semi": "ControlledScoreSelect-module-scss-module__KAZM9W__txt-24-semi",
});
